import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-survey-check',
  templateUrl: './survey-check.component.html',
  styleUrls: ['./survey-check.component.scss']
})
export class SurveyCheckComponent implements OnInit {
  idiomaActual:string;
  displayedColumns: string[] = ['section', 'value'];
  tablaDatos:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SurveyCheckComponent>,
    private translateSrv: TranslateService
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log(this.data.datos);
    this.cargarTabla();
  }

  cargarTabla(){
    this.tablaDatos= new MatTableDataSource(this.data.datos);
  }

  salir() {
    this.dialogRef.close();
  }

}
